import { CarFront, CheckSquare, GitPullRequestArrow, Target, UserRound, Users, type LucideIcon } from 'lucide-react';
import type { SearchGroupType } from '@nexops/shared';
import type { MessageKey } from '@/i18n/I18nProvider';
import type { BadgeTone } from '@/shared/ui';

/** Ikona, kolor (spójny z `nav-accent`) i etykieta grupy wyników. */
export const GROUP_META: Record<SearchGroupType, { icon: LucideIcon; color: string; labelKey: MessageKey }> = {
  CUSTOMER: { icon: Users, color: '#3b82f6', labelKey: 'search.groups.CUSTOMER' as MessageKey },
  CONTACT: { icon: UserRound, color: '#0ea5e9', labelKey: 'search.groups.CONTACT' as MessageKey },
  LEAD: { icon: Target, color: '#8b5cf6', labelKey: 'search.groups.LEAD' as MessageKey },
  TASK: { icon: CheckSquare, color: '#14b8a6', labelKey: 'search.groups.TASK' as MessageKey },
  REQUEST: { icon: GitPullRequestArrow, color: '#6366f1', labelKey: 'search.groups.REQUEST' as MessageKey },
  VEHICLE: { icon: CarFront, color: '#0891b2', labelKey: 'search.groups.VEHICLE' as MessageKey },
};

/** Klucz tłumaczenia statusu rekordu w danej grupie (słowniki istnieją już w innych modułach). */
export function statusLabelKey(type: SearchGroupType, status: string): MessageKey | null {
  switch (type) {
    case 'CUSTOMER':
      return `customerStatus.${status}` as MessageKey;
    case 'LEAD':
      return `leads.stage.${status}` as MessageKey;
    case 'TASK':
      return `tasks.status.${status}` as MessageKey;
    case 'REQUEST':
      return `workflow.status.${status}` as MessageKey;
    case 'VEHICLE':
      return `fleet.vehicleStatus.${status}` as MessageKey;
    default:
      return null;
  }
}

const TONES: Record<string, BadgeTone> = {
  ACTIVE: 'success',
  IN_SERVICE: 'warning',
  DECOMMISSIONED: 'neutral',
  RECOVERED: 'success',
  WON: 'success',
  APPROVED: 'success',
  DONE: 'success',
  NEW: 'info',
  OPEN: 'info',
  PENDING: 'warning',
  TO_CONTACT: 'warning',
  IN_PROGRESS: 'warning',
  OFFER: 'violet',
  APPROVAL: 'violet',
  INACTIVE: 'neutral',
  CANCELLED: 'neutral',
  LOST: 'danger',
  REJECTED: 'danger',
};

export const statusTone = (status: string): BadgeTone => TONES[status] ?? 'neutral';
